"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var Routes_1 = require("../../constants/Routes");
var PageLoader_1 = __importDefault(require("../PageLoader"));
var SubscriptionPlanForm_1 = __importDefault(require("./SubscriptionPlanForm"));
var SubscriptionPlanPostItem_1 = __importDefault(require("./SubscriptionPlanPostItem"));
var subscriptionSlice_1 = require("../../features/subscription/subscriptionSlice");
var globalSlice_1 = require("../../features/global/globalSlice");
var SubscriptionPlans_1 = require("../../constants/SubscriptionPlans");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SubscriptionPlanModal = function () {
    var _a, _b;
    var dispatch = react_redux_1.useDispatch();
    var isModalOpen = react_redux_1.useSelector(subscriptionSlice_1.selectSubscriptionModalOpened);
    var postData = react_redux_1.useSelector(subscriptionSlice_1.selectSubscriptionModalPostData);
    var subscriptionPlan = react_redux_1.useSelector(subscriptionSlice_1.selectSubscriptionPlanData);
    var subscriptionPlanLoading = react_redux_1.useSelector(subscriptionSlice_1.selectSubscriptionPlanLoading);
    var subscriptionProcess = react_redux_1.useSelector(subscriptionSlice_1.selectSubscriptionProcess);
    var subscriptionQty = react_redux_1.useSelector(subscriptionSlice_1.selectSubscriptionQty);
    var _c = react_1.useState(false), isChecked = _c[0], setIsChecked = _c[1];
    var t = react_i18next_1.useTranslation('common').t;
    // getting subscription plan schema for rendering conditions
    var planSchema = react_1.useMemo(function () {
        return SubscriptionPlans_1.SUBSCRIPTION_PLANS.find(function (subscription) { return subscription.name === (subscriptionPlan === null || subscriptionPlan === void 0 ? void 0 : subscriptionPlan.name); });
    }, [subscriptionPlan]);
    var subscribeToPlan = function (subscriptionData) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!subscriptionData) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(subscriptionSlice_1.setSubscription(subscriptionData))];
                case 2:
                    response = _a.sent();
                    if (!response.error && response.errorCode === 0) {
                        window.location = response.formUrl;
                    }
                    else {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('SUBSCRIPTION_PLANS_MODAL.TOAST_MESSAGES.REQUEST_ERROR'),
                            appearance: 'error',
                        }));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('SUBSCRIPTION_PLANS_MODAL.TOAST_MESSAGES.REQUEST_ERROR'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 4];
                case 4:
                    setIsChecked(false);
                    dispatch(subscriptionSlice_1.closeSubscriptionModal());
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (subscriptionPlanLoading || subscriptionProcess) && react_1.default.createElement(PageLoader_1.default, null),
        react_1.default.createElement(semantic_ui_react_1.Modal, { onClose: function () {
                dispatch(subscriptionSlice_1.closeSubscriptionModal());
                setIsChecked(false);
            }, closeIcon: true, open: isModalOpen, className: classnames_1.default(styles_module_scss_1.default.subscription_plan_modal), size: "tiny" }, isModalOpen && subscriptionPlan && planSchema && (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.modal_content) },
            react_1.default.createElement("img", { className: styles_module_scss_1.default.subscription_plan_image, src: planSchema.mainIcon, alt: planSchema.name }),
            react_1.default.createElement("h2", { className: styles_module_scss_1.default.subscription_plan_name }, t("SUBSCRIPTION_PLANS." + planSchema.name + ".title")),
            react_1.default.createElement("h3", { className: styles_module_scss_1.default.subscription_plan_description }, t("SUBSCRIPTION_PLANS." + planSchema.name + ".description")),
            planSchema.hasForm && (react_1.default.createElement(SubscriptionPlanForm_1.default, { daysCountStep: (_b = (_a = subscriptionPlan.servicesList[0]) === null || _a === void 0 ? void 0 : _a.step) !== null && _b !== void 0 ? _b : planSchema.options.defaultStep, maxDaysCount: planSchema.options.defaultMaxDaysCount, subscriptionBasePrice: subscriptionPlan.price })),
            !!postData && planSchema.hasPostCard && (react_1.default.createElement(SubscriptionPlanPostItem_1.default, { postData: postData, planPrice: subscriptionPlan.price })),
            react_1.default.createElement("section", { className: styles_module_scss_1.default.terms_conditions },
                react_1.default.createElement("p", { className: styles_module_scss_1.default.terms_conditions_text },
                    t('SUBSCRIPTION_PLANS_MODAL.TERMS_CONDITIONS.TEXT') + ' ',
                    react_1.default.createElement(react_router_dom_1.Link, { to: Routes_1.Routes.TermsAndConditions.path, className: styles_module_scss_1.default.terms_conditions_link, target: "_blank" }, t('SUBSCRIPTION_PLANS_MODAL.TERMS_CONDITIONS.LINK'))),
                react_1.default.createElement(semantic_ui_react_1.Checkbox, { toggle: true, onChange: function () { return setIsChecked(!isChecked); } })),
            react_1.default.createElement("section", { className: styles_module_scss_1.default.actions },
                react_1.default.createElement("button", { onClick: function () {
                        dispatch(subscriptionSlice_1.closeSubscriptionModal());
                        setIsChecked(false);
                    }, className: classnames_1.default('btn btn-outline-primary', styles_module_scss_1.default.action), disabled: subscriptionProcess }, t('SUBSCRIPTION_PLANS_MODAL.ACTIONS.CANCEL')),
                react_1.default.createElement("button", { onClick: function () {
                        return subscribeToPlan({
                            subscriptionPlanId: subscriptionPlan.id,
                            payment_bank: planSchema.paymentBank,
                            currency: planSchema.currency,
                            post_id: postData.id,
                            subscriptionQty: subscriptionQty,
                        });
                    }, className: classnames_1.default('btn btn-primary', styles_module_scss_1.default.action), disabled: !isChecked || subscriptionProcess }, postData.isDeveloper
                    ? t('SUBSCRIPTION_PLANS_MODAL.ACTIONS.MAKE_PAYMENT_DEVELOPER')
                    : t('SUBSCRIPTION_PLANS_MODAL.ACTIONS.MAKE_PAYMENT_INDIVIDUAL'))))))));
};
exports.default = SubscriptionPlanModal;
